import useFindLocation from "hooks/useFindLocation";
import { useNavigatePage } from "hooks/useNavigatePage";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { changeLanguage, selectLanguage } from "redux/reducers/languageReducer";
import { selectActiveNewsModal } from "redux/reducers/newsModalReducer";
import { offSideBar, selectSideBar, switchSideBar } from "redux/reducers/sideBarReducer";
import PcMenuCom from "./PcMenuCom";
import {
  Container,
  ENG,
  KOR,
  LanguageSelector,
  Logo,
  LogoImg,
  MenuBtn,
  SideWrap,
  SketchScan,
  SketchScanText,
  Wrapper,
} from "./style";
const Header = () => {
  const dispatch = useDispatch();
  const nav = useNavigatePage();
  const findLocation = useFindLocation();

  // 언어 관련
  const currentLanguage = useSelector(selectLanguage);
  const changeLanguageHandler = () => {
    dispatch(changeLanguage());
  };

  // 검색 관련
  const inputRef = useRef();
  const searchHandler = (event) => {
    event.preventDefault();
    const location = findLocation(inputRef.current.value);
    console.log(location);
    inputRef.current.value = "";
  };

  // 로고 클릭 관련
  const logoClickHandler = () => {
    dispatch(offSideBar());
    nav("/home");
  };

  // 모바일 사이드바 관련
  const sideBarHandler = () => dispatch(switchSideBar());

  // news_event 모바일 모달창 켜있을때는 사이드바 숨기기
  const newsModalState = useSelector(selectActiveNewsModal);
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  // 모바일 버전에서 메뉴 클릭시 로고, 스케치 스캔 가리기
  const sideBarState = useSelector(selectSideBar);

  return (
    // mobile 버전에서 뉴스모달 나타나있으면 탑바 제거
    <Wrapper isActive={newsModalState && !isPc}>
      {/* 검색관련 */}

      {/* <form onSubmit={searchHandler}>
                <input type="text" ref={inputRef} />
                <button>검색</button>
              </form> */}

      <Container>
        <Logo onClick={logoClickHandler} isActive={sideBarState && !isPc}>
          <LogoImg src="/assets/img/Header_3.svg" alt="logo" />
        </Logo>
        {/* Pc Menu */}
        <PcMenuCom />

        <SideWrap isActive={sideBarState && !isPc}>
          {/* Language Select */}
          <LanguageSelector onClick={changeLanguageHandler} isActive={sideBarState && !isPc}>
            <KOR currentLanguage={currentLanguage}>KOR</KOR>
            <ENG currentLanguage={currentLanguage}>ENG</ENG>
          </LanguageSelector>
          {/* SketchScan */}
          <SketchScan href="/sketch_scan" isActive={sideBarState && !isPc}>
            <SketchScanText>Sketch Scan</SketchScanText>
            <img loading="lazy" src="/assets/img/Header_2.svg" alt="sketchScanImg" />
          </SketchScan>
        </SideWrap>

        {/* Mobile Menu Btn */}
        <MenuBtn onClick={sideBarHandler}>
          <img loading="lazy" src={sideBarState ? "/assets/img/Header_7.svg" : "/assets/img/Header_4.svg"} alt="menu" />
        </MenuBtn>
      </Container>
    </Wrapper>
  );
};

export default Header;
